module.exports = __webpack_public_path__ + "img/logo-jardindelvalle.e600ce56.png";